import { gql } from '@apollo/client';

const PatientListInfoShared = gql`
  fragment PatientListInfoShared on Patient {
    id
    firstName
    lastName
    dob
    includeEot
    scanReady
    settingsOverride
    hasPlan
    hasFreeTrial
    legacyId
    orders {
      id
    }
    partnerLocation {
      id
      enablePaidInOffice
    }
    account {
      id
      users {
        id
        firstName
        lastName
        email
        hasCognitoSub
      }
    }
    createdAt
  }
`;

export default PatientListInfoShared;
